module.exports = __webpack_public_path__ + "img/grey-cross.acbfe662.svg";